/* eslint-disable max-len */
import { API_CONFIG } from 'constants/config';

export const apiInboxExportCSV = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/csv`;
export const apiReportExportCSV = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/csv`;
export const apiMessages = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/`;
export const apiGetMessage = messageId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/${messageId}/`;
export const apiGetFullThreadMessage = messageId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/${messageId}/full_thread/`;
export const apiGetMessageFiles = messageId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/${messageId}/files/`;
export const apiGetMessageBulkFiles = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/bulk_files/`;
export const apiDownloadMessageFile = messageId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/${messageId}/download`;
export const apiBulkMessage = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/bulk/`;
export const apiBulkUpdateReadMessage = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/mark-read/`;
export const apiBulkUpdateArchivedMessage = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}messages/mark-archived/`;

export const apiCreateContact = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}contacts/`;
export const apiGetContact = contactId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}contacts/${contactId}/`;
export const apiUpdateContact = apiGetContact;
export const apiContactPitchPreviews = contactSequenceId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${contactSequenceId}/pitches/preview/`
);

export const apiUpdateContactPitchPreviews = contactSequenceId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${contactSequenceId}/pitches/`
);
export const apiExportSequenceContacts = () => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/export/`
);

// REPORT
export const apiGetReportSequences = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/sequences`;
export const apiGetReportAccounts = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/accounts`;
export const apiGetReportOpportunities = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/opportunities`;

// CONFIG
export const apiGetConfig = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}config/`;

// RECOVER PASSWORD
export const apiRecoverPassword = () => `${API_CONFIG.API_BASE}api-auth/password/reset/`;
export const apiConfirmNewPassword = (uid, token) => `${process.env.API_BASE}password/reset/confirm/${uid}/${token}/`;

// EMAIL PROVIDER CONFIG
export const apiGetEmailConfigs = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}email-configs/`;
export const apiGetOrganizationEmailConfigs = organizationId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}organizations/${organizationId}/email-configs/`
);
export const apiUpdateOrganizationEmailConfig = (organizationId, emailConfigId) => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}organizations/${organizationId}/email-configs/${emailConfigId}/`
);
export const apiOrganizationEmailConfigAddRemoveAccounts = organizationId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}organizations/${organizationId}/email-configs/accounts/`
);
export const apiGetAccountEmailConfigs = accountId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-configs/`
);
export const apiDeleteEmailConfig = (accountId, emailConfigId) => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-configs/${emailConfigId}`
);
export const apiCreateEmailImapSmtpConfig = accountId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-imap-smtp-configs/`
);
export const apiUpdateEmailImapSmtpConfig = (accountId, emailConfigId) => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-imap-smtp-configs/${emailConfigId}/`
);
export const apiCreateEmailKnownImapConfig = accountId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-known-imap-configs/`
);
export const apiUpdateEmailKnownImapConfig = (accountId, emailConfigId) => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-known-imap-configs/${emailConfigId}/`
);
export const apiUpdateEmailConfig = emailConfigId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}email-configs/${emailConfigId}/`
);
export const apiGoogleOauthUrl = () => `${API_CONFIG.API_BASE}nylas/google_oauth_redirect/`;
export const apiUpdateEmailOauthConfig = (accountId, emailConfigId) => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/email-configs-update/${emailConfigId}/`
);
export const apiMicrosoftOauthUrl = () => `${API_CONFIG.API_BASE}nylas/microsoft_oauth_redirect/`;

// CONTACTS
export const apiBulkCreateContacts = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}contacts/bulk/`;
export const apiGetContactsPreview = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/preview/`;
export const apiImportCurrentContacts = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}contacts/current/`;
export const apiGetContacts = accountId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/contacts/`;
export const apiDestroyAccountContacts = accountId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/sequence-contacts/`;
export const apiExportAccountSequenceContacts = accountId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/sequence-contacts/export/`
);
export const apiMarkAsFinishedSeqContact = seqContactId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${seqContactId}/mark-as-finished/`
);
export const apiUnmarkAsFinishedSeqContact = seqContactId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${seqContactId}/unmark-as-finished/`
);
export const apiBulkUnmarkAsFinishedSeqContacts = () => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/unmark-as-finished/`
);
export const apiBulkMarkAsFinishedSeqContacts = () => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/mark-as-finished/`
);

// OUTLETS
export const apiGetOutlets = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outlets/`;

// CSV
export const apiGetCsvHeaders = csvId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}contacts/csv/temp/${csvId}/headers/`;

// SEQUENCES
export const apiCreateSequence = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequences/`;
export const apiSequence = sequenceId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequences/${sequenceId}/`;
export const apiGetSequences = campaignID => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/${campaignID}/sequences/`;
export const apiCreateSequenceContacts = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequences/contacts/bulk/`;
export const apiDuplicateSequence = id => `${apiSequence(id)}duplicate/`;


// CAMPAIGNS
export const apiGetCampaigns = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/`;
export const apiDuplicateCampaign = id => `${apiGetCampaigns()}${id}/duplicate/`;
export const urlCampaignById = campaignId => `/campaigns/${campaignId}`;

// ERRORS
export const apiGetError = code => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}errors/${code}`;

// ACCOUNTS
export const apiGetAccounts = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/`;
export const apiUpdateAccount = accountId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/`;
export const urlAccountById = accountId => `/accounts/${accountId}`;

// Update User Account
export const apiUpdateUser = () => `${API_CONFIG.API_BASE}api-auth/user/`;
export const apiUpdateEmail = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}user/change-email/`;
export const apiVerifyEmail = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}user/verify-email/`;
export const apiUpdatePassword = () => `${API_CONFIG.API_BASE}api-auth/password/change/`;
export const apiManagedServicesUpdatePassword = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}user/managed-services/change-password/`;

// Dashboard
export const apiDashboardStats = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}dashboard/`;
export const apiDashboardTopLeads = () => `${apiDashboardStats()}top_leads/`;
export const apiDashboardTopLeadsExportCSV = () => `${apiDashboardTopLeads()}csv/`;

// PITCHES
export const apiGetTemplatePitches = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitch-templates/`;
export const apiCreateTemplatePitch = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitch-templates/`;
export const apiUpdateTemplatePitch = pitchId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitch-templates/${pitchId}/`;
export const apiValidatePitch = () =>
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/validate/`;
export const apiCheckPitchQuality = () =>
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/check-quality/`;
export const apiPitchUploadImage = () =>
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}images/`;
export const apiCheckEmailSize = () =>
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/check-email-size/`;
export const apiGetPitchCompletion = () =>
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/completions/`;


// TIMLINE
export const apiGetTimelines = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}timelines/`;

// COVERAGE
export const apiGetMention = mentionId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}media-monitoring/mentions/${mentionId}`;
export const apiGetMentions = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}media-monitoring/mentions/`;
export const apiUpdateMention = mentionId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}media-monitoring/mentions/${mentionId}/`;

// Opportunities
export const apiGetOpportunities = () => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}opportunities/`;
export const apiGetOpportunity = oppId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}opportunities/${oppId}`;
export const apiUpdateOpportunity = oppId => `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}opportunities/${oppId}/`;
